import React from 'react';
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useDataValue } from 'globals/contexts/dataContext';
import routes from 'globals/routes';

import './projectDetailPage.css';
const ProjectDetailPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  return <section className="landing">
    <div className="logo">
      <img src={content['logo']} alt="" />
    </div>
    <div className="coverContent">
      <div className="textContent">
        <div className="title">What Cafe Interior Calligraphy</div>
        <div className="quote">
          <div className="skill">Font Style, Interior Font Creations</div>
          <div className="style">Branding Design</div>
          <div className="location">Locations: 1/F & Shop A, G/F, Shining Building, 477-481 Jaffe Road, Causeway Bay</div>          
        </div>
        <div className="brief">With all tools and supplies provided, you will be engaged in a traditional Chinese calligraphy session with a local professional. I am a national champion in calligraphy, and I am proficient in English, Mandarin, and Cantonese.</div>
        <Link className="filter" to={routes.pageWithLangAndFilter('commercial', currentLanguage, 'SemiCursive')}>
          <div class="styleIcon">
            <img src="./media/iconFontStyleSemiCursive.png" />
          </div>
          <div class="name">
            <div class="line1">行書</div>
            <div class="line2">Semi-Cursive Script</div>
          </div>
        </Link>
      </div>
      <div className="imageContent">
        <img src="./media/projectCover.png" alt="" />
      </div>
    </div>
  </section>
}
export default ProjectDetailPage;